import axios from 'axios';
import { config } from '../../../../config/envs';
import { generateTraceId } from '../../../helpers';

export class ChargesAPI {
  static async createPix(clientId, planId) {
    const response = await axios.post(
      `${config.app.jusbillUrl}/charges/pix/${clientId}`,
      { plan_id: planId },
      { headers: { 'x-trace-id': generateTraceId() } },
    );
    return response;
  }
}
